import { render } from "./UnderLine.vue?vue&type=template&id=06c9fb01&ts=true"
import script from "./UnderLine.vue?vue&type=script&lang=ts"
export * from "./UnderLine.vue?vue&type=script&lang=ts"

import "./UnderLine.vue?vue&type=style&index=0&id=06c9fb01&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__